(function ($) {
    'use strict';

    var prfx = 'acom';

    acom_app.views.Panel = Backbone.View.extend({
        el: 'body',
        template: _.template($('#' + prfx + '-panel-template').html()),
        initialize: function () {
            this.helper = acom_app.models.helper
            this.settings = acom_app.models.settings
        },

        render: function () {
            this.close()

            var panel_menus = window.acom_app.models.settings.get('content.panel_menus')
            var menus = window.acom_app.models.helper.get('menus')
            var social = window.acom_app.models.settings.get('accounts.social')
            var user_role = window.acom_app.models.helper.get('user_role')

            var result = {
                menus: [],
                social: social
            }

            if (panel_menus.length > 0) {
                panel_menus.forEach(function (item, i) {
                    // Check visibility

                    if(item.slug == '') return

                    var menu_items = menus[item.slug].items
                    if (menu_items.length > 0) {

                        var rule = item.rule.replace('group-', '')

                        if (rule == 'guests' && user_role != null) return
                        if (rule != 'guests' && rule != 'all' && user_role == null) return
                        if (rule != 'all' && rule != 'users' && user_role != rule) return


                        var tmp_items = {}
                        if (menu_items.length > 0) {
                            _.each(menu_items, function (val, key) {
                                var childs = []

                                _.each(menu_items, function (item, key) {
                                    if(+val.ID == +item.menu_item_parent){
                                        childs.push({
                                            parent: item.menu_item_parent,
                                            title: item.title,
                                            url: item.url
                                        })
                                    }
                                })

                                if(val.menu_item_parent == '0') {
                                    tmp_items[val.ID] = {
                                        parent: val.menu_item_parent,
                                        childs: childs,
                                        title: val.title,
                                        url: val.url
                                    }
                                }
                            });
                        }

                        result.menus.push(tmp_items)
                    }
                })
            }

            result = _.extend({}, result, this.settings.toJSON());

            var html = this.template(result)
            this.$el.append(html)

            setTimeout(function () {
                $('.cd-panel-wrapper .cd-nav-submenu').each(function (i) {
                    var height = $(this).height()
                    $(this).attr('height', height)
                        .css('height', 0)
                })
            },0)

            $('body').append('<div class="acom-overlay"></div>')

            this.bindEvents()

            return this
        },
        bindEvents: function () {
            this.$('.acom-icon').on('click', function (e) {
                e.preventDefault()

                var $el = $(this).closest('.cd-nav-link')
                var $submenu = $el.find('.cd-nav-submenu')

                if(!$submenu.hasClass('visible')){
                    var height = $submenu.attr('height')
                    $submenu.css('height', height)
                }else{
                    $submenu.css('height', 0)
                }

                $el.toggleClass('subnav-visible')
                $submenu.toggleClass('visible')
            })
        },
        close: function () {
            $('body > .cd-panel-wrapper').remove()
            $('body > .acom-overlay').remove()
            this.unbind()
        }
    })
})(jQuery)